var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_718_11332",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 16,
    width: 7,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.1997H6.76503V23.1384H0V16.1997Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_718_11332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.7322C0 21.2944 1.64561 22.3091 3.04146 21.6077C4.57131 20.8389 4.58667 18.6605 3.06781 17.8702C1.67048 17.1431 0 18.157 0 19.7322Z",
    fill: "#A5E48B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_718_11332",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V23.1371H0V0Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_718_11332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2733 21.1972L12.7193 16.746L9.74433 15.1978L5.16477 12.8148L4.64174 12.5428C3.75198 12.0802 3.19373 11.1607 3.19373 10.1579V9.00662C3.19373 7.00599 5.30114 5.70641 7.08878 6.60465L14.8396 10.4992C15.7187 10.9409 15.7187 12.196 14.8395 12.6377C13.9672 13.0759 13.9583 14.3178 14.8242 14.7684L15.1066 14.9154C15.4939 15.1169 15.9543 15.1202 16.3444 14.9242L18.2429 13.9704C20.218 12.9781 20.218 10.1588 18.243 9.16643L3.89504 1.95711C2.10739 1.05889 0 2.35846 0 4.35908V12.3738C0 12.8822 0.282875 13.3483 0.733814 13.583L3.19373 14.8626L6.73889 16.7079L9.71383 18.256L16.0268 21.5407L18.7984 22.9828C18.9927 23.0839 19.2085 23.1367 19.4276 23.1367H20.7989C21.8745 23.1367 22.2274 21.6937 21.2733 21.1972Z",
    fill: "#A5E48B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.16269c2e3920f547fcb69e20881e9775.svg";
export { ForwardRef as ReactComponent };